//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://13.54.184.217:5000";

const DEFAULT_API_BASE_URL = "https://afdani.com" || "https://afdani.com";

const API_BASE_URL = String(
	process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL,
)
	.trim()
	.replace(/\/$/, "");

const isAfdaniHost = (url) =>
	/(^|\.)afdani\.com$/i.test(url.hostname);

export const buildAssetUrl = (rawValue) => {
	const raw = String(rawValue || "").trim();

	if (!raw || raw === "null" || raw === "undefined") {
		return "";
	}

	const dedupedAbsolute = raw.replace(
		/^(https?:\/\/[^/]+)\/+(?:https?:\/\/)?(?:www\.)?afdani\.com\/+/i,
		"$1/",
	);

	if (dedupedAbsolute.startsWith("data:")) {
		return dedupedAbsolute;
	}

	if (/^https?:\/\//i.test(dedupedAbsolute)) {
		try {
			const parsedUrl = new URL(dedupedAbsolute);
			if (isAfdaniHost(parsedUrl) && parsedUrl.protocol === "http:") {
				const relativeAssetPath = `${parsedUrl.pathname.replace(/^\/+/, "")}${parsedUrl.search}${parsedUrl.hash}`;
				return relativeAssetPath ? `${API_BASE_URL}/${relativeAssetPath}` : API_BASE_URL;
			}
		} catch (error) {
			return dedupedAbsolute;
		}

		return dedupedAbsolute;
	}

	const relativePath = dedupedAbsolute
		.replace(/^\/+(?:www\.)?afdani\.com\/+/i, "")
		.replace(/^(?:www\.)?afdani\.com\/+/i, "")
		.replace(/^\/+/, "");

	return relativePath ? `${API_BASE_URL}/${relativePath}` : "";
};

export default API_BASE_URL;
